import React from 'react';
import styles from './SVHeader.module.css';
import {ReactComponent as HamburgerSvg} from "../../assets/static/hamburger.svg";

function SVHeader() {
    return (
        <div className={styles.container}>
            <div className={styles.brandname_container}>
                <div className={styles.brandname_inner}>
                <h1 className={styles.brandname_title}>Stu VanZyverden</h1>
                <h1 className={styles.brandname_subtitle}>Real Estate</h1>
                </div>
            </div>
            <div className={styles.hamburger_container}>
                <div className={styles.hamburger_inner}>
                    <HamburgerSvg className={styles.hamburger_svg} />
                </div>
            </div>
        </div>
    );
}

export default SVHeader;

